<template>
  <div>
    <div class="font-bold p-2">Actions</div>
    <div class="flex gap-2 p-2 text-gray-300">
      <SMButton v-tippy="'Duplicate'" icon="copy" :on-click="duplicate" />
      <SMButton v-tippy="'Delete'" icon="delete" :on-click="remove" />
    </div>
    <div
      v-if="!hasBookedSeatsInSelection && (draftEvent || pauseEvent) && hasMeta"
      class="md-subheading px-2 my-2 bg-gray-200"
    >
      Attributes
    </div>
    <ul class="space-y-2 p-2">
      <li v-if="!hasBookedSeatsInSelection && (draftEvent || pauseEvent) && hasMeta">
        <SMInput v-tippy="'Meta 1'" :value="meta1" icon="1" :placeholder="meta1Label" @change="onChangeMeta1" />
      </li>
      <li v-if="!hasBookedSeatsInSelection && (draftEvent || pauseEvent) && hasMeta">
        <SMInput v-tippy="'Meta 2'" :value="meta2" icon="2" :placeholder="meta2Label" @change="onChangeMeta2" />
      </li>
    </ul>
    <ul class="space-y-2 p-2">
      <li>
        <SMIcon class="text-sm" icon="info" />
        <i class="text-xs">Multiple objects selected. Select objects of the same type to see more options.</i>
      </li>
    </ul>
  </div>
</template>
<script lang="ts">
import eventbus from 'tiny-emitter/instance';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import forEach from 'lodash/forEach';
import SMInput from '@/components/ui/SMInput.vue';
import SMButton from '@/components/ui/SMButton.vue';
import { EVENTSTATUS, SEATSTATUS, TYPE } from '@/constants';
import SMIcon from '@/components/ui/SMIcon.vue';

export default {
  components: {
    SMInput,
    SMButton,
    SMIcon,
  },
  props: ['units', 'hasMeta'],
  computed: {
    meta1() {
      const meta1s = map(this.units, (unit) => unit.attributes.meta1);
      const uniqmeta1s = uniq(meta1s);
      if (uniqmeta1s.length > 1) {
        return '';
      } else {
        return uniqmeta1s[0];
      }
    },
    meta2() {
      const meta2s = map(this.units, (unit) => unit.attributes.meta2);
      const uniqmeta2s = uniq(meta2s);
      if (uniqmeta2s.length > 1) {
        return '';
      } else {
        return uniqmeta2s[0];
      }
    },
    meta1Label() {
      const meta1s = map(this.units, (unit) => unit.attributes.meta1);
      const uniqmeta1s = uniq(meta1s);
      if (uniqmeta1s.length > 1) {
        return 'Multiple meta 1 values assigned';
      } else {
        return 'Meta 1';
      }
    },
    meta2Label() {
      const meta2s = map(this.units, (unit) => unit.attributes.meta2);
      const uniqmeta2s = uniq(meta2s);
      if (uniqmeta2s.length > 1) {
        return 'Multiple meta 2 values assigned';
      } else {
        return 'Meta 2';
      }
    },
    hasBookedSeatsInSelection() {
      let bookedUnits = 0;
      if (this.units.length > 0) {
        this.units.forEach((u) => {
          if (u.type === TYPE.SEAT) {
            bookedUnits +=
              u.attributes.status === SEATSTATUS.OCCUPIED || u.attributes.status === SEATSTATUS.RESERVED || u.inCart
                ? 1
                : 0;
          } else if (u.type === TYPE.TABLE) {
            const bookedTableSeats = u.seats.filter(
              (s) =>
                s.attributes.status === SEATSTATUS.OCCUPIED || s.attributes.status === SEATSTATUS.RESERVED || s.inCart
            );
            bookedUnits += bookedTableSeats.length > 0 ? 1 : 0;
          }
        });
      }
      return !!bookedUnits;
    },
    draftEvent() {
      return this.$app.props.status === EVENTSTATUS.DRAFT;
    },
    pauseEvent() {
      return this.$app.props.status === EVENTSTATUS.PAUSED;
    },
  },
  methods: {
    duplicate() {
      eventbus.emit('selection:clone');
    },
    remove() {
      eventbus.emit('selection:remove');
    },
    onChangeMeta1(value) {
      this.$app.seatmap.triggerUnsavedChanges(true);
      forEach(this.units, (unit) => unit.changeMeta1(value.trim()));
    },
    onChangeMeta2(value) {
      this.$app.seatmap.triggerUnsavedChanges(true);
      forEach(this.units, (unit) => unit.changeMeta2(value.trim()));
    },
  },
};
</script>
